"use client";

import Image from "next/image";
import dynamic from "next/dynamic";
import { memo, useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { useContactModal } from "../../context/ContactModalContext";
import Breadcrumbs from "./BreadCrumbComponent";

const CalendlyForm = dynamic(() => import("../calendly-form"), {
  ssr: false,
  loading: () => (
    <div className="w-full rounded-2xl bg-white/10 backdrop-blur p-6 min-h-[280px]" />
  ),
});

const ServicesBanner = ({ name, breadcrumbProps }) => {
  const { t } = useTranslation("common");
  const { openModal } = useContactModal();

  // ✅ delay heavy Calendly until after LCP
  const [showCalendly, setShowCalendly] = useState(false);
  useEffect(() => {
    const id = window.setTimeout(() => setShowCalendly(true), 1200); // tune 800–2000ms
    return () => window.clearTimeout(id);
  }, []);

  return (
    // <div className={`relative w-full h-auto lg:h-[600px] ${className}`}>
    <div className="relative w-full aspect-[16/9] sm:aspect-auto sm:h-[800px] lg:h-[600px]">
      <Image
        src="/banners/commonbanner2.webp"
        alt="Prism Digital Marketing Services Banner"
        fill
        priority
        quality={65}
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 1200px"
        className="object-cover object-top z-0"
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/40 z-0" />

      {/* Overlay Content */}
      <div className="relative lg:absolute lg:inset-0 z-10 flex items-center py-10 lg:py-0">
        <div className="w-full max-w-[1600px] mx-auto px-4 md:px-[60px]">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 text-white">
            {/* Left Content - 65% */}
            <div className="w-full lg:w-[65%] flex flex-col justify-center">
              <div className="mb-3">
                <Breadcrumbs {...breadcrumbProps} />
              </div>

              <h1 className="leading-[120%] font-medium text-[36px] sm:text-[40px] lg:text-[55px] capitalize mb-5 mt-0">
                {name}
              </h1>

              {/* Desktop Get In Touch Button (hidden on mobile) */}
              <button
                onClick={() => openModal({ trigger: "frame-component8" })}
                className="hidden sm:block w-fit text-[16px] bg-white text-black rounded-full px-6 py-3 font-medium cursor-pointer hover:opacity-70 transition"
              >
                {t("btnTxt.getInTouch")}
              </button>
            </div>

            {/* Right */}
            <div className="w-full lg:w-[35%]">
              <div className="min-h-[300px]">
                {showCalendly && <CalendlyForm />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesBanner;
